import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { useMutation } from '@tanstack/react-query'
import { Col, Row, Space, Switch, Typography, theme } from 'antd'
import checkPointApi from 'api/checkPointApi'
import { useFormik } from 'formik'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import ToastHelper from 'general/helpers/ToastHelper'
import ValidationSchema from 'general/utils/ValidationSchema'
import { useEffect, useRef } from 'react'

export default function EditModal({
  open,
  toggleModalState,
  refetchData,
  defaultFormData,
}) {
  const { token } = theme.useToken()
  const modalRef = useRef(null)
  const { mutate: editCheckPoint, isLoading: isCreating } = useMutation({
    mutationKey: 'editCheckPoint',
    mutationFn: (params) => checkPointApi.update(params),
    onError: (err) => ToastHelper.showError(err?.message ?? 'Có lỗi xảy ra'),
    onSuccess: () => {
      ToastHelper.showSuccess('Tạo mới tuyến đường thành công')
      toggleModalState(false)
      void refetchData()
    },
  })
  const formik = useFormik({
    initialValues: defaultFormData,
    validationSchema: ValidationSchema.createNewCheckPoint,
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: (values) => editCheckPoint(values),
  })
  const { resetForm } = formik

  useEffect(() => {
    if (!open) {
      resetForm()
    }
  }, [open, resetForm])
  return (
    <DraggableModal
      title="Chỉnh sửa điểm soát vé"
      cancelText="Huỷ bỏ"
      applyText="Lưu thay đổi"
      ref={modalRef}
      isOpen={open}
      isLoading={isCreating}
      onOpenChange={(state) => toggleModalState(state)}
      handleApplyChanges={() => formik.handleSubmit()}
    >
      <form noValidate onSubmit={formik.handleSubmit}>
        <Space
          direction="vertical"
          size="large"
          style={{ paddingTop: '1rem', width: '100%' }}
        >
          {/* Tên  */}
          <Row align={'middle'}>
            <Col span={6}>
              <Typography.Text strong>
                Tên điểm soát vé
                <span className="text-danger ml-1">*</span>
              </Typography.Text>
            </Col>
            <Col span={24 - 6}>
              <CustomAntInput
                borderRadius="sm"
                type="text"
                inputProps={{
                  autoComplete: 'off',
                  placeholder: 'Nhập tên điểm soát vé',
                  status: formik.getFieldMeta('nameLocationCheckTicket').error
                    ? 'error'
                    : '',
                  value: formik.getFieldProps('nameLocationCheckTicket').value,
                  name: formik.getFieldProps('nameLocationCheckTicket').name,
                  onChange: formik.getFieldProps('nameLocationCheckTicket')
                    .onChange,
                }}
              />
            </Col>
          </Row>
          {/* Mô tả */}
          <Row align={'middle'}>
            <Col span={6}>
              <Typography.Text strong>Mô tả</Typography.Text>
            </Col>
            <Col span={24 - 6}>
              <CustomAntInput
                type="textarea"
                borderRadius="sm"
                inputProps={{
                  value: formik.getFieldProps('description').value,
                  name: formik.getFieldProps('description').name,
                  onChange: formik.getFieldProps('description').onChange,
                  autoComplete: 'off',
                  placeholder: 'Một vài mô tả về điểm soát vé....',
                  status: formik.getFieldMeta('description').error
                    ? 'error'
                    : '',
                  maxLength: 100,
                  style: {
                    minHeight: 120,
                    maxHeight: 300,
                  },
                }}
              />
            </Col>
          </Row>
          {/* Tình trạng sử dụng */}
          <Row align={'middle'}>
            <Col span={6}>
              <Typography.Text strong>Tình trạng sử dụng</Typography.Text>
            </Col>
            <Col span={24 - 6}>
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                checked={formik.getFieldProps('availability').value}
                onChange={(checked) =>
                  formik.setFieldValue('availability', checked)
                }
              />
            </Col>
          </Row>
        </Space>
      </form>
    </DraggableModal>
  )
}
